<template>
    <div>
        <b-tabs content-class="mt-3" pills>
            <b-tab
                v-for="(item, index) in samples"
                v-bind:key="'sample-category-' + index"
                :title="item.name"
            >
                <ul class="item-list" id="icon-select">
                    <li
                        v-for="(sItem, sIndex) in item.samples"
                        v-bind:key="'sample-item-' + index + '-' + sIndex"
                    >
                        <input
                            type="radio"
                            name="sample"
                            :checked="
                                !model.customFileSample &&
                                    model.sample === sItem.id
                            "
                            :id="'icon-sample-' + index + '-' + sIndex"
                            v-on:change="selectSample(sItem.id)"
                        />
                        <label
                            :for="'icon-sample-' + index + '-' + sIndex"
                            class="d-block"
                            :title="sItem.name"
                            ><img :src="sItem.image" :alt="sItem.name" />
                        </label>
                    </li>
                </ul>
            </b-tab>
            <b-tab :title="$t('Egyedi minta')">
                <div class="creator-title">
                    {{ $t("Egyedi minta feltöltése") }}:
                </div>
                <input
                    type="file"
                    ref="file"
                    v-on:change="handleFileUpload"
                    name="custom-icon"
                    class="d-none"
                    accept="image/png,image/jpeg,image/webp,image/gif"
                    id="custom-icon-file-sample"
                />
                <button
                    class="btn btn-simple upload"
                    v-on:click="$refs.file.click()"
                >
                    {{ $t("Fájl feltöltés") }}
                </button>
                <button
                    class="btn btn-link"
                    v-if="model.customFileSample"
                    v-on:click="removeCustom"
                >
                    {{ $t("Egyedi minta törlése") }}
                </button>
                <div class="text-danger small mt-2" v-if="error">
                    {{ error }}
                </div>
                <cropper
                    class="cropper mt-3"
                    v-if="source"
                    :src="source"
                    @change="change"
                ></cropper>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import { canvasToDataUrl, debounce } from "@/lib/sticker/image";

const MAX_UPLOAD_BYTES = 15 * 1024 * 1024;

export default {
    name: "TabSample",
    props: ["model", "samples"],
    components: {
        Cropper
    },
    data() {
        return {
            source: null,
            error: null
        };
    },
    created() {
        // Cropping fires on every drag frame; only encode once it settles.
        this.change = debounce(({ canvas }) => {
            const image = canvasToDataUrl(canvas, {
                maxSize: 1000,
                type: "image/png"
            });
            if (image) {
                this.$emit("update", { customFileSample: image });
            }
        }, 200);
    },
    beforeDestroy() {
        this.change.cancel();
        this.releaseSource();
    },
    methods: {
        selectSample(id) {
            this.removeCustom();
            this.$emit("update", { sample: id });
        },
        removeCustom() {
            this.change.cancel();
            this.releaseSource();
            this.$refs.file.value = "";
            this.$emit("update", { customFileSample: null });
        },
        releaseSource() {
            if (this.source) {
                URL.revokeObjectURL(this.source);
                this.source = null;
            }
        },
        handleFileUpload() {
            const file = this.$refs.file.files[0];
            this.error = null;
            if (!file) {
                return;
            }
            if (!file.type.startsWith("image/")) {
                this.error = this.$translate.t("Csak képfájl tölthető fel.");
                return;
            }
            if (file.size > MAX_UPLOAD_BYTES) {
                this.error = this.$translate.t(
                    "A fájl túl nagy (legfeljebb 15 MB)."
                );
                return;
            }
            this.releaseSource();
            this.source = URL.createObjectURL(file);
        }
    }
};
</script>

<style>
.vue-advanced-cropper__background {
    background: white !important;
}
.vue-advanced-cropper__foreground {
    background: #ccc !important;
}
.cropper {
    max-height: 400px;
}
</style>
